var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-card-group",
        { attrs: { deck: "" } },
        [
          _c("b-card", {
            attrs: { "footer-tag": "footer", "header-tag": "header" },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _vm.customtitleright && _vm.customtitleright !== undefined
                        ? _c("h6", { staticClass: "mb-0 float-left" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.customtitleright) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customtitleright && _vm.customtitleright !== undefined
                        ? _c("br")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customtitleleft && _vm.customtitleleft !== undefined
                        ? _c("h6", { staticClass: "mb-0 float-left" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.customtitleleft) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showbackbutton
                        ? _c(
                            "b-button",
                            {
                              staticClass: "float-left",
                              attrs: {
                                to: _vm.urlbackbutton,
                                size: "sm",
                                variant: "info",
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" Kembali\n        "),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.customtitleleft === undefined &&
                      _vm.customtitleright === undefined
                        ? _c(
                            "h6",
                            { staticClass: "mt-1 ml-2 mb-0 float-left" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.title) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          attrs: { title: _vm.modalQR.title, size: "xl" },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-footer",
                              fn: function ({}) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.printDivQR()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-print mr-1",
                                      }),
                                      _vm._v(
                                        "\n              Print\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.modalQR.paginate
                                    ? [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mt-3 mr-2",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _c(
                                                  "b-form",
                                                  { attrs: { inline: "" } },
                                                  [
                                                    _c("b-form-select", {
                                                      staticClass:
                                                        "mb-2 mr-sm-2 mb-sm-0",
                                                      attrs: {
                                                        id: "per-page-select",
                                                        options: [
                                                          5, 8, 10, 25, 50, 100,
                                                        ],
                                                        size: "sm w-35",
                                                      },
                                                      on: {
                                                        change: _vm.fetchQRCode,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.modalQR.limit,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.modalQR,
                                                            "limit",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "modalQR.limit",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mt-3",
                                                attrs: { cols: "9" },
                                              },
                                              [
                                                _c("b-pagination", {
                                                  staticClass: "mr-sm-2",
                                                  attrs: {
                                                    "per-page":
                                                      _vm.modalQR.limit,
                                                    "total-rows":
                                                      _vm.modalQR.count,
                                                    "first-text": "First",
                                                    "last-text": "Last",
                                                    "next-text": "Next",
                                                    "prev-text": "Prev",
                                                    size: "sm",
                                                  },
                                                  on: {
                                                    input: _vm.fetchQRCode,
                                                  },
                                                  model: {
                                                    value: _vm.modalQR.page,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.modalQR,
                                                        "page",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "modalQR.page",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.modalQR.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.modalQR, "show", $$v)
                            },
                            expression: "modalQR.show",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-center",
                              attrs: { id: "printerDiv" },
                            },
                            [
                              _c("iframe", {
                                class: _vm.modalQR.class,
                                attrs: { src: _vm.modalQR.url },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          attrs: {
                            title: _vm.modalQRLembaga.title,
                            size: "lg",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-footer",
                              fn: function ({}) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.printDivQRLembaga()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-print mr-1",
                                      }),
                                      _vm._v(
                                        "\n              Print QR\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.modalQRLembaga.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.modalQRLembaga, "show", $$v)
                            },
                            expression: "modalQRLembaga.show",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-center",
                              attrs: { id: "printerDivLembaga" },
                            },
                            [
                              _c("VueQRCodeComponent", {
                                attrs: {
                                  size: 480,
                                  text: _vm.modalQRLembaga.text,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          attrs: { title: _vm.modalLimitRek.title, size: "md" },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-footer",
                              fn: function ({ cancel }) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "danger" },
                                      on: {
                                        click: function ($event) {
                                          return cancel()
                                        },
                                      },
                                    },
                                    [_vm._v(" Batal ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.handleSubmitLimitRek.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Simpan\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.modalLimitRek.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.modalLimitRek, "show", $$v)
                            },
                            expression: "modalLimitRek.show",
                          },
                        },
                        [
                          _c(
                            "form",
                            { ref: "form" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Max Transaction",
                                    "label-for": "max-transaction-input",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: { id: "max-transaction-input" },
                                    on: {
                                      keypress: _vm.onlyNumber,
                                      input: function ($event) {
                                        return _vm.formatRupiah(
                                          $event,
                                          "max_transaction"
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.nominal.max_transaction,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.nominal,
                                          "max_transaction",
                                          $$v
                                        )
                                      },
                                      expression: "nominal.max_transaction",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showbtnoption
                        ? _c(
                            "b-dropdown",
                            {
                              staticClass: "float-right",
                              attrs: { right: "", size: "sm", text: "Options" },
                            },
                            [
                              _vm.showcheckduplicate
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        size: "sm",
                                        target: "_blank",
                                        variant: "warning",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.checkDuplicate()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-trash-restore",
                                      }),
                                      _vm._v(" Check Duplicate\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.viewqr
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        size: "sm",
                                        target: "_blank",
                                        variant: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.printQr(
                                            "all",
                                            "Semua QR Santri"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-id-card" }),
                                      _vm._v(" Lihat QR\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showcreatebutton
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        to: _vm.urlcreate,
                                        size: "sm",
                                        variant: "primary",
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "fas fa-plus" }),
                                      _vm._v(" Tambah Data\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showgeneratecode
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { size: "sm", variant: "info" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.generateCode()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-file-download",
                                      }),
                                      _vm._v(" Kode Aktivasi\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showwageneratecode
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { size: "sm", variant: "info" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.SendWaActivation()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-mobile" }),
                                      _vm._v(" Kode Aktivasi WA\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isexported
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { size: "sm", variant: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.exportExcel()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-file-excel",
                                      }),
                                      _vm._v(" Export\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isimported
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        to: _vm.urlimport,
                                        size: "sm",
                                        variant: "success",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-file-import",
                                      }),
                                      _vm._v(" Import\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showprint
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-info",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.printData()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "fas fa-print" }),
                                      _vm._v(" Print\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isuploaded
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        to: _vm.urlupload,
                                        size: "sm",
                                        variant: "info",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-file-upload",
                                      }),
                                      _vm._v(" Upload\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showrekeningbutton
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        to: _vm.urlrekening,
                                        size: "sm",
                                        variant: "success",
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "fas fa-cube" }),
                                      _vm._v(" Lihat Rekening\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showbtntagihanspp
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        to: _vm.urlunpaid,
                                        size: "sm",
                                        title: "Tagihan SPP Belum Lunas",
                                        variant: "info",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-money-bill-wave",
                                      }),
                                      _vm._v(" SPP Belum Lunas\n          "),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showgeneraterekeningbutton
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { size: "sm", variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.generateRekening()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-check-circle",
                                      }),
                                      _vm._v(" Generate Rekening\n          "),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { display: "none" },
                        attrs: { id: "printerDiv" },
                      }),
                      _vm._v(" "),
                      _vm.showfilterbutton
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle",
                                  value: _vm.variablefilter,
                                  expression: "variablefilter",
                                },
                              ],
                              staticClass: "float-right mr-1",
                              attrs: { size: "sm", variant: "primary" },
                            },
                            [
                              _c("i", { staticClass: "fa fa-filter" }),
                              _vm._v(" Filter Data\n        "),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isfiltered
                        ? _c(
                            "b-col",
                            {
                              staticClass: "float-right mr-1",
                              attrs: { cols: "3" },
                            },
                            [
                              _c(
                                "b-input-group",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Cari data...",
                                      size: "sm",
                                    },
                                    on: {
                                      keypress: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.searchData.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function ($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-input-group-append",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            text: "Button",
                                            variant: "primary",
                                          },
                                          on: { click: _vm.searchData },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-search",
                                          }),
                                          _vm._v(" Cari\n              "),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "default",
                  fn: function () {
                    return [
                      _c("b-table", {
                        ref: "PrintData",
                        staticStyle: { "min-height": "200px" },
                        attrs: {
                          id: "my-table",
                          bordered: true,
                          busy: _vm.isBusy,
                          fields: _vm.fields,
                          hover: true,
                          items: _vm.items,
                          striped: true,
                          responsive: "",
                          "show-empty": "",
                          small: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-busy",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center text-danger my-2",
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "align-middle",
                                        attrs: {
                                          type: "grow",
                                          label: "Loading...",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("strong", { staticClass: "ml-2" }, [
                                        _vm._v("Memuat data..."),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            _vm.topheader
                              ? {
                                  key: "thead-top",
                                  fn: function () {
                                    return [
                                      _c(
                                        "b-tr",
                                        _vm._l(
                                          _vm.dataTopHeader,
                                          function (v, i) {
                                            return _c(
                                              "b-th",
                                              {
                                                key: i,
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                                attrs: {
                                                  colspan: v.colspan,
                                                  variant: v.variant,
                                                },
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "sr-only",
                                                }),
                                                _vm._v(
                                                  _vm._s(v.name) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                            {
                              key: "head(checkbox)",
                              fn: function (data) {
                                return [
                                  _c("b-form-checkbox", {
                                    staticClass: "ml-2",
                                    attrs: { value: data.label },
                                    on: { change: _vm.changeCheckedAll },
                                    model: {
                                      value: _vm.isCheckedAll,
                                      callback: function ($$v) {
                                        _vm.isCheckedAll = $$v
                                      },
                                      expression: "isCheckedAll",
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "cell(customer_name_link)",
                              fn: function (row) {
                                return [
                                  _c(
                                    "b-link",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.showsppcard(
                                            row.item.customer_id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(row.item.customer_name_link) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "empty",
                              fn: function () {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    _c(
                                      "h1",
                                      { staticClass: "badge badge-info" },
                                      [
                                        _c("i", { staticClass: "fa fa-file" }),
                                        _vm._v(" Data Kosong"),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "cell(is_autodebit)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.is_autodebit
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Yes")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "badge badge-danger" },
                                          [_vm._v("No")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(is_need_jurusan)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.is_need_jurusan
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Ya")]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "badge badge-secondary",
                                          },
                                          [_vm._v("Tidak")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(description)",
                              fn: function (item) {
                                return [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(item.item.description),
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "cell(is_vendor)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.is_vendor
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Yes")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "badge badge-danger" },
                                          [_vm._v("No")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(products)",
                              fn: function (item) {
                                return [
                                  item?.item?.products
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          item?.item?.products.split("|"),
                                          function (p, x) {
                                            return _c(
                                              "span",
                                              {
                                                key: x,
                                                staticClass:
                                                  "badge badge-success mr-1",
                                              },
                                              [_vm._v(_vm._s(p))]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [_vm._v("-")]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(jurusans)",
                              fn: function (item) {
                                return [
                                  item?.item?.jurusans &&
                                  item.item.jurusans.length
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          item.item.jurusans,
                                          function (j, x) {
                                            return _c(
                                              "span",
                                              {
                                                key: x,
                                                staticClass:
                                                  "badge badge-info mr-1",
                                              },
                                              [_vm._v(_vm._s(j))]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [_vm._v("-")]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(full_name)",
                              fn: function (item) {
                                return [
                                  item?.item?.full_name &&
                                  item?.item?.full_name != ""
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.decodeHtml(
                                                item?.item?.full_name
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.decodeHtml(
                                                  item?.item?.first_name
                                                ) +
                                                  " " +
                                                  _vm.decodeHtml(
                                                    item?.item?.last_name
                                                  )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(code)",
                              fn: function (item) {
                                return [
                                  _vm.showfullcode
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.item.code) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm.showqr
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { size: "sm" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.printQrLembaga(
                                                    item.item.id,
                                                    _vm.decodeHtml(
                                                      item.item.name
                                                    ),
                                                    "pendaftaran"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "QR Code\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                ("0" + item.item.code).slice(-2)
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(bulan_awal)",
                              fn: function (item) {
                                return [
                                  item.item.bulan_awal && item.item.tahun_awal
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.setAjaran(
                                                item.item.tahun_awal,
                                                item.item.bulan_awal
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [_vm._v("-")]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(bulan_akhir)",
                              fn: function (item) {
                                return [
                                  item.item.bulan_akhir && item.item.tahun_akhir
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.setAjaran(
                                                item.item.tahun_akhir,
                                                item.item.bulan_akhir
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [_vm._v("-")]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(balance)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.balance.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(pendaftaran_balance)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          (
                                            item.item.pendaftaran_balance || 0
                                          ).toLocaleString("id-ID")
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(total_balance)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.total_balance.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(admin)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.admin.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(min_saldo)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.min_saldo.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(admin_bank)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.admin_bank.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(admin_nash)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.admin_nash.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(admin_institution)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.admin_institution.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(max_transaction)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.max_transaction.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(amount)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.amount.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(gross_amount)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.gross_amount.toLocaleString(
                                            "id",
                                            "ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(fee)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.fee.toLocaleString(
                                            "id",
                                            "ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(price)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.price.toLocaleString(
                                            "id",
                                            "ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(amount_kredit)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.amount_kredit.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(min_nominal_teller)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.min_nominal_teller.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(max_nominal_teller)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.max_nominal_teller.toLocaleString(
                                            "id-ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(mutasi)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    item.item.amount > 0
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  "-" +
                                                    item.item.amount.toLocaleString(
                                                      "id-ID"
                                                    )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : item.item.amount_kredit > 0
                                      ? _c(
                                          "span",
                                          { staticClass: "text-success" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  item.item.amount_kredit.toLocaleString(
                                                    "id-ID"
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(is_active)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.is_active
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Active")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "badge badge-danger" },
                                          [_vm._v("Non Active")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(status)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.status
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Active")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "badge badge-danger" },
                                          [_vm._v("Non Active")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(is_transfered)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.is_transfered == "success"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Success")]
                                        )
                                      : item.item.is_transfered == "process"
                                      ? _c(
                                          "span",
                                          { staticClass: "badge badge-info" },
                                          [_vm._v("Process")]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-warning",
                                          },
                                          [_vm._v("Pending")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(is_implemented)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.is_implemented
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Implemented")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "badge badge-danger" },
                                          [_vm._v("Waiting List")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(is_staff)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.is_staff
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Yes")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "badge badge-danger" },
                                          [_vm._v("No")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(transaction_status)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.transaction_status === "pending"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-warning",
                                          },
                                          [_vm._v("Pending")]
                                        )
                                      : item.item.transaction_status ===
                                        "settlement"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Settlement")]
                                        )
                                      : item.item.transaction_status ===
                                        "expired"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "badge badge-secondary",
                                          },
                                          [_vm._v("Expired")]
                                        )
                                      : item.item.transaction_status ===
                                        "rejected"
                                      ? _c(
                                          "span",
                                          { staticClass: "badge badge-danger" },
                                          [_vm._v("Rejected")]
                                        )
                                      : item.item.transaction_status ===
                                        "canceled"
                                      ? _c(
                                          "span",
                                          { staticClass: "badge badge-info" },
                                          [_vm._v("Canceled")]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(name)",
                              fn: function (item) {
                                return [
                                  item.item.level
                                    ? _c(
                                        "div",
                                        [
                                          _vm._l(
                                            item.item.level,
                                            function (v, i) {
                                              return _c("i", { key: i }, [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(" ") +
                                                    "\n                "
                                                ),
                                              ])
                                            }
                                          ),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.decodeHtml(item.item.name)
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        2
                                      )
                                    : _c("div", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.decodeHtml(item.item.name)
                                            ) +
                                            "\n              "
                                        ),
                                      ]),
                                ]
                              },
                            },
                            {
                              key: "cell(checkbox)",
                              fn: function (item) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "text-center" },
                                    [
                                      item.item.is_transfered !== "success"
                                        ? _c("b-form-checkbox", {
                                            staticClass: "ml-2",
                                            attrs: { value: item.item.id },
                                            model: {
                                              value: _vm.checkbox,
                                              callback: function ($$v) {
                                                _vm.checkbox = $$v
                                              },
                                              expression: "checkbox",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(level)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.item.level) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(saldo)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.saldo.toLocaleString(
                                            "id",
                                            "ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(saldo_awal)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.saldo_awal.toLocaleString(
                                            "id",
                                            "ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(saldo_akhir)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "float-right" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.item.saldo_akhir.toLocaleString(
                                            "id",
                                            "ID"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(is_pusat)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.is_pusat
                                      ? _c(
                                          "span",
                                          { staticClass: "badge badge-info" },
                                          [_vm._v("Yes")]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-warning",
                                          },
                                          [_vm._v("No")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(paid)",
                              fn: function (item) {
                                return [
                                  _c("div", { staticClass: "text-center" }, [
                                    item.item.paid === "Y"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Lunas")]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-warning",
                                          },
                                          [_vm._v("Belum Lunas")]
                                        ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(birth_date)",
                              fn: function (item) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.formatBirthDate(
                                          item.item.birth_date
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(created_at)",
                              fn: function (item) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.formatBirthDateTime(
                                          item.item.created_at
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(transaction_date)",
                              fn: function (item) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.formatBirthDateTime(
                                          item.item.transaction_date
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(icon)",
                              fn: function (item) {
                                return [
                                  item.item.icon && item.item.icon !== "-"
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: item.item.icon,
                                              alt: "icon",
                                              width: "30",
                                            },
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [_vm._v("-")]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(file_nilai)",
                              fn: function (item) {
                                return [
                                  item.item.file_nilai
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c("i", {
                                            staticClass: "fa pointer fs-1-75",
                                            class:
                                              _vm.getExtention(
                                                item.item.file_nilai
                                              ) === "pdf"
                                                ? "fa-file-pdf text-info"
                                                : "fa-file-excel text-success",
                                            attrs: {
                                              title: item.item.file_nilai
                                                .split("/")
                                                .pop(),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.previewFile(
                                                  item.item.file_nilai
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [_vm._v("-")]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(path_url)",
                              fn: function (item) {
                                return [
                                  item.item.path_url
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c("i", {
                                            staticClass: "fa pointer fs-1-75",
                                            class:
                                              _vm.getExtention(
                                                item.item.path_url
                                              ) === "pdf"
                                                ? "fa-file-pdf text-info"
                                                : "fa-file-excel text-success",
                                            attrs: {
                                              title: item.item.path_url
                                                .split("/")
                                                .pop(),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.previewFile(
                                                  item.item.path_url
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [_vm._v("-")]
                                      ),
                                ]
                              },
                            },
                            _vm.showaction
                              ? {
                                  key: "cell(actions)",
                                  fn: function (item) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            "b-dropdown",
                                            {
                                              staticClass: "float-right",
                                              attrs: {
                                                right: "",
                                                size: "sm",
                                                text: "Aksi",
                                                variant: "info",
                                              },
                                            },
                                            [
                                              _vm.showcreatewithidbutton
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        to:
                                                          _vm.urlcreate +
                                                          "?parent_id=" +
                                                          item?.item
                                                            ?.order_number +
                                                          "&institution_id=" +
                                                          item?.item
                                                            ?.institution_id,
                                                        size: "sm",
                                                        title: "Tambah Data",
                                                        variant:
                                                          "outline-success",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-plus",
                                                      }),
                                                      _vm._v(
                                                        " Tambah Data\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showsubdata
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        title: _vm.subdatatext,
                                                        to:
                                                          _vm.urlsubdata +
                                                          "?id=" +
                                                          item.item.id,
                                                        size: "sm",
                                                        variant:
                                                          "outline-success",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-plus",
                                                      }),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.subdatatext
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.scanqrwa
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        title: "Scan QR WA",
                                                        to:
                                                          _vm.urlscanqrwa +
                                                          "?id=" +
                                                          item.item.id,
                                                        size: "sm",
                                                        variant:
                                                          "outline-success",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-qrcode",
                                                      }),
                                                      _vm._v(
                                                        "\n                    Scan QR WA\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showactivebutton &&
                                              !item.item.is_lock &&
                                              !item.item.kode_booking &&
                                              !item.item.is_pusat
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        title:
                                                          _vm.activetextbutton
                                                            ? _vm.activetextbutton
                                                            : item.item
                                                                .is_active
                                                            ? "Non-aktifkan"
                                                            : "Aktifkan",
                                                        variant: item.item
                                                          .is_active
                                                          ? "info"
                                                          : "success",
                                                        size: "sm",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.ChangeStatus(
                                                            item.item.id,
                                                            item.item.is_active
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        class:
                                                          "fa fa-" +
                                                          (item.item.is_active
                                                            ? "times"
                                                            : "check"),
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.activetextbutton
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.activetextbutton
                                                              )
                                                            ),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  item.item
                                                                    .is_active
                                                                    ? "Non-aktifkan"
                                                                    : "Aktifkan"
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showstatusbutton &&
                                              !item.item.is_pusat
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        title:
                                                          _vm.activetextbutton
                                                            ? _vm.activetextbutton
                                                            : item.item.status
                                                            ? "Non-Aktifkan"
                                                            : "Aktifkan",
                                                        variant: item.item
                                                          .status
                                                          ? "info"
                                                          : "success",
                                                        size: "sm",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.ChangeStatusPPOB(
                                                            item.item.id,
                                                            item.item.status
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        class:
                                                          "fa fa-" +
                                                          (item.item.status
                                                            ? "times"
                                                            : "check"),
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.activetextbutton
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.activetextbutton
                                                              )
                                                            ),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  item.item
                                                                    .status
                                                                    ? "Non-Aktifkan"
                                                                    : "Aktifkan"
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showactivesettdatafix
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        title:
                                                          item.item.status === 1
                                                            ? "Non-aktifkan"
                                                            : "Aktifkan",
                                                        variant:
                                                          item.item.status === 1
                                                            ? "info"
                                                            : "success",
                                                        size: "sm",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.ChangeStatusSettDataFix(
                                                            item.item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        class:
                                                          "fa fa-" +
                                                          (item.item.status ===
                                                          1
                                                            ? "times"
                                                            : "check"),
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              item.item
                                                                .status === 1
                                                                ? "Non-aktifkan"
                                                                : "Aktifkan"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showactivebutton &&
                                              item.item.kode_booking &&
                                              !item.item.is_implemented
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        title:
                                                          _vm.activetextbutton
                                                            ? _vm.activetextbutton
                                                            : item.item
                                                                .is_implemented
                                                            ? "Terimplementasi"
                                                            : "Implementasikan",
                                                        variant: item.item
                                                          .is_implemented
                                                          ? "info"
                                                          : "success",
                                                        size: "sm",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.ChangeStatusBooking(
                                                            item.item.id,
                                                            item.item
                                                              .is_implemented
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        class:
                                                          "fa fa-" +
                                                          (item.item
                                                            .is_implemented
                                                            ? "times"
                                                            : "check"),
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.activetextbutton
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.activetextbutton
                                                              )
                                                            ),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  item.item
                                                                    .is_implemented
                                                                    ? "Terimplementasi"
                                                                    : "Implementasikan"
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showcreatewithidbutton &&
                                              _vm.showeditbutton &&
                                              !item.item.is_lock
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        to:
                                                          "/" +
                                                          _vm.url +
                                                          "/" +
                                                          item.item.id +
                                                          "?parent_id=" +
                                                          item.item.parent_id +
                                                          "&institution_id=" +
                                                          item?.item
                                                            ?.institution_id,
                                                        size: "sm",
                                                        title: "Edit",
                                                        variant: "warning",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-edit",
                                                      }),
                                                      _vm._v(
                                                        " Ubah\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.showcreatewithidbutton &&
                                              _vm.showeditbutton &&
                                              !item.item.is_lock
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        size: "sm",
                                                        title: "Edit",
                                                        variant: "warning",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.goToEdit(
                                                            item.item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-edit",
                                                      }),
                                                      _vm._v(
                                                        " Ubah\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showdeletebutton &&
                                              !item.item.is_lock &&
                                              !item.item.is_pusat
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        size: "sm",
                                                        title: "Delete",
                                                        variant: "danger",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.deleteData(
                                                            item.item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-trash",
                                                      }),
                                                      _vm._v(
                                                        " Hapus\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.viewqr
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        size: "sm",
                                                        title: "Lihat QR",
                                                        variant: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          _vm.printQr(
                                                            item.item.id,
                                                            _vm.decodeHtml(
                                                              item.item
                                                                .full_name
                                                            )
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-id-card",
                                                      }),
                                                      _vm._v(
                                                        " Lihat QR\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.customNominal &&
                                              item.item.is_autodebit
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        to: `/${_vm.url}/custom-nominal/${item.item.id}`,
                                                        size: "sm",
                                                        title: "Custom Nominal",
                                                        variant: "success",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-money-bill-wave",
                                                      }),
                                                      _vm._v(
                                                        " Custom Nominal\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showuservendorbutton
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      attrs: {
                                                        to: `${_vm.urluservendor}/${item.item.id}`,
                                                        size: "sm",
                                                        variant: "success",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-users",
                                                      }),
                                                      _vm._v(
                                                        " List User Vendor\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showrekeningbuttondetail
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      attrs: {
                                                        to: `${_vm.urlrekening}/${item.item.id}`,
                                                        size: "sm",
                                                        variant: "success",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-cube",
                                                      }),
                                                      _vm._v(
                                                        " Lihat Rekening\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showsantributton
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      attrs: {
                                                        size: "sm",
                                                        variant: "info",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.showModalSantri(
                                                            item.item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-users",
                                                      }),
                                                      _vm._v(
                                                        " Lihat Santri\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.updatelimitrekening
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      attrs: {
                                                        size: "sm",
                                                        variant: "warning",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.showModalLimitRek(
                                                            item.item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-money-bill-wave",
                                                      }),
                                                      _vm._v(
                                                        " Ubah Limit Transaksi\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showdetailbutton
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      attrs: {
                                                        to:
                                                          _vm.urldetail !== "/"
                                                            ? `${_vm.urldetail}/${item.item.id}`
                                                            : `/${_vm.url}/${item.item.id}`,
                                                        size: "sm",
                                                        variant: "info",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-eye",
                                                      }),
                                                      _vm._v(
                                                        " Show Details\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                }
                              : null,
                            {
                              key: "cell(show_details)",
                              fn: function (row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        variant: row.detailsShowing
                                          ? "warning"
                                          : "info",
                                        size: "sm",
                                      },
                                      on: { click: row.toggleDetails },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            row.detailsShowing ? "Hide" : "Show"
                                          ) +
                                          " Details\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.generateinvoice
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            variant: "warning",
                                            size: "sm",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.GenerateInvoice(
                                                row.item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Generate Invoice\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.payinvoice
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            variant: "warning",
                                            size: "sm",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.PayInvoice(row.item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Bayar Invoice\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "row-details",
                              fn: function (item) {
                                return [
                                  _c("b-table", {
                                    attrs: {
                                      id: "my-table",
                                      bordered: true,
                                      fields: _vm.fieldsdetail,
                                      hover: true,
                                      items: item.item.details,
                                      responsive: "",
                                      "show-empty": "",
                                      small: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(price)",
                                          fn: function (sub) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "float-right" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        sub.item.price.toLocaleString(
                                                          "id",
                                                          "ID"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(is_pokok)",
                                          fn: function (sub) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "text-center" },
                                                [
                                                  sub.item.is_pokok
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "badge badge-info",
                                                        },
                                                        [_vm._v("Ya")]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "badge badge-warning",
                                                        },
                                                        [_vm._v("Bukan")]
                                                      ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(amount)",
                                          fn: function (sub) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "float-right" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        sub.item.amount.toLocaleString(
                                                          "id",
                                                          "ID"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(amount_kredit)",
                                          fn: function (sub) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "float-right" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        sub.item.amount_kredit.toLocaleString(
                                                          "id",
                                                          "ID"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              },
                            },
                            {
                              key: "custom-foot",
                              fn: function () {
                                return [
                                  !_vm.isBusy && _vm.showjumlahbukubesar
                                    ? _c(
                                        "b-tr",
                                        [
                                          _c(
                                            "b-th",
                                            {
                                              staticClass: "text-right",
                                              attrs: { colspan: "4" },
                                            },
                                            [_vm._v("JUMLAH")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.saldo_awal > 0
                                                    ? _vm.saldo_awal.toLocaleString(
                                                        "id",
                                                        "ID"
                                                      )
                                                    : 0
                                                ) + "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.total_debit > 0
                                                    ? _vm.total_debit.toLocaleString(
                                                        "id",
                                                        "ID"
                                                      )
                                                    : 0
                                                ) + "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.total_kredit > 0
                                                    ? _vm.total_kredit.toLocaleString(
                                                        "id",
                                                        "ID"
                                                      )
                                                    : 0
                                                ) + "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.saldo_akhir.toLocaleString(
                                                    "id",
                                                    "ID"
                                                  )
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isBusy && _vm.showjumlahneraca
                                    ? _c(
                                        "b-tr",
                                        [
                                          _c(
                                            "b-th",
                                            {
                                              staticClass: "text-right",
                                              attrs: { colspan: "2" },
                                            },
                                            [
                                              _vm._v(
                                                "TOTAL " +
                                                  _vm._s(
                                                    _vm.title.toUpperCase()
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.total_saldo_awal.toLocaleString(
                                                    "id",
                                                    "ID"
                                                  )
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.total_debit.toLocaleString(
                                                    "id",
                                                    "ID"
                                                  )
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.total_kredit.toLocaleString(
                                                    "id",
                                                    "ID"
                                                  )
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.total_saldo_akhir.toLocaleString(
                                                    "id",
                                                    "ID"
                                                  )
                                                ) + "\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isBusy && _vm.showsummary
                                    ? _c(
                                        "b-tr",
                                        [
                                          _c(
                                            "b-th",
                                            {
                                              staticClass: "text-right",
                                              attrs: {
                                                colspan: _vm.fields?.length - 1,
                                              },
                                            },
                                            [_vm._v("TOTAL ")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.total_saldo_awal.toLocaleString(
                                                    "id",
                                                    "ID"
                                                  )
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isBusy && _vm.showsummarynominatif
                                    ? _c(
                                        "b-tr",
                                        [
                                          _c(
                                            "b-th",
                                            {
                                              staticClass: "text-right",
                                              attrs: {
                                                colspan: _vm.fields?.length - 1,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Total dari " +
                                                  _vm._s(_vm.meta.count) +
                                                  " rekening\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.totalnominatif.toLocaleString(
                                                    "id",
                                                    "ID"
                                                  )
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isBusy && _vm.showsummaryspp
                                    ? _c(
                                        "b-tr",
                                        [
                                          _c(
                                            "b-th",
                                            {
                                              staticClass: "text-right",
                                              attrs: {
                                                colspan: _vm.fields?.length - 2,
                                              },
                                            },
                                            [_vm._v("TOTAL ")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.summarySpp.total_paid.toLocaleString(
                                                    "id",
                                                    "ID"
                                                  )
                                                ) + "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.summarySpp.total_unpaid.toLocaleString(
                                                    "id",
                                                    "ID"
                                                  )
                                                ) + "\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            !_vm.isBusy
                              ? {
                                  key: "table-caption",
                                  fn: function () {
                                    return [
                                      _vm._v("\n              Total Rows : "),
                                      _c("b", [_vm._v(_vm._s(_vm.meta.count))]),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  },
                  proxy: true,
                },
                !_vm.isBusy && _vm.showpagination
                  ? {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "b-row",
                            { attrs: { "align-h": "end" } },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "my-0 text-right",
                                  attrs: { md: "2", sm: "1" },
                                },
                                [
                                  _c(
                                    "b-form",
                                    { attrs: { inline: "" } },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "mr-sm-2",
                                          attrs: {
                                            for: "per-page-select",
                                            size: "sm",
                                          },
                                        },
                                        [_vm._v(" Per Page ")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        staticClass: "mb-2 mr-sm-2 mb-sm-0",
                                        attrs: {
                                          id: "per-page-select",
                                          options: _vm.pageoptions,
                                          size: "sm w-35",
                                        },
                                        on: { change: _vm.getData },
                                        model: {
                                          value: _vm.meta.limit,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.meta, "limit", $$v)
                                          },
                                          expression: "meta.limit",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-pagination", {
                                staticClass: "mr-sm-2",
                                attrs: {
                                  "per-page": _vm.meta.limit,
                                  "total-rows": _vm.meta.count,
                                  "first-text": "First",
                                  "last-text": "Last",
                                  "next-text": "Next",
                                  "prev-text": "Prev",
                                  size: "sm",
                                },
                                on: { input: _vm.getData },
                                model: {
                                  value: _vm.meta.page,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.meta, "page", $$v)
                                  },
                                  expression: "meta.page",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("PreviewFile", {
        attrs: { show: _vm.modalFile.show, url: _vm.modalFile.url },
        on: { close: _vm.resetModalFile },
      }),
      _vm._v(" "),
      _c("br"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }